module.exports = __webpack_public_path__ + "static/szenario2_4-77e6c5f8c5056a01cf64685611f4af9a.png";